<div class="row mt-4">
  <div class="col-md-12">
    <div class="row mb-3">
      <div class="col-3 mr-auto">
        <h3>ShortCode Message Console</h3>
      </div>
      <div class="col-2 ml-auto">
        <label class="mb-0" for=""><u>Items Per Page</u></label>
        <select (change)="itemsPerPageChange($event.target.value)" class="form-control">
          <option *ngFor="let ipp of pagingList">{{ipp}}</option>
        </select>
      </div>
    </div>
    <div class="row">
      <div class="col-3">
        <label for=""><u>Filter by ShortCode</u></label>
        <input type="text" [(ngModel)]="filterable.shortCode" class="form-control" placeholder="Pls enter ShortCode" />
      </div>
      <div class="col text-right align-self-end">
        <button class="btn btn-primary btn-sm mr-2" (click)="search()">Search</button>
        <button class="btn btn-danger btn-sm mr-2" (click)="clear()">Clear</button>
      </div>
    </div>
  </div>
</div>
<div class="mt-3 mb-2 row">
  <div class="col-10 align-self-center">
    Total Results: {{totalItems}} &nbsp;&nbsp; <i class="fas fa-question-circle" placement="top"></i> &nbsp;<a target="_blank" [routerLink]="['/dashboard/support/msg-template']">View template field description</a>
  </div>
  <div class="col-2 ml-auto text-right">

    <button class="btn btn-outline-success text-dark font-weight-bold" (click)="openModal(newMsgModel)">+ New Template</button>
  </div>
</div>
<!-- <div class="table-responsive"> -->
<table id="metaList" class="table table-striped table-bordered mt-3 text-center" style="width:100%">
  <thead>
    <th>ShortCode</th>
    <th>Language</th>
    <th>Messages</th>
    <th>Operate</th>
  </thead>
  <tbody>
    <tr *ngIf="loading">
      <td colspan="4">
        <div class="loader">Loading...</div>
      </td>
    </tr>
    <tr *ngIf="emptyResult">
      <td colspan="4">
        <div class="alert alert-warning">Empty Result...</div>
      </td>
    </tr>
    <tr *ngFor="let msg of msgList; index as i;">
      <td class="align-middle">{{msg.shortCode}}</td>
      <td class="align-middle">{{msg.lang}}</td>
      <td>
        <table class="table table-striped" style="width:100%" >
          <tr>
            <th>Invalid Sub Keyword</th><td class="text-left">{{msg.subInvalidMsg}}</td><th>Invalid Unsub Keyword</th><td class="text-left">{{msg.unsubInvalidMsg}}</td>
          </tr>
          <tr>
            <th>Sub Help</th><td  class="text-left">{{msg.subHelpMsg}}</td><th>Unsub Help</th><td class="text-left">{{msg.unsubHelpMsg}}</td>
          </tr>
          <tr>
            <th>Unsub All</th><td colspan="3" class="text-left">{{msg.unsubAllMsg}}</td>
          </tr>
        </table>
      </td>
      <td class="align-middle">
        <a type="button" class="btn btn-sm btn-primary mr-2 mt-2" placement="top" ngbTooltip="View & Edit" [routerLink]="['/dashboard/tx/sc-msg-detail', msg.id]" >
          <i class="fas fa-pen"></i>
        </a>
        <button type="button" class="btn btn-sm btn-danger mr-2 mt-2" placement="top" ngbTooltip="Delete" (click)="deleteMsg(msg.id)">
          <i class="fas fa-trash"></i>
        </button>
      </td>
    </tr>
  </tbody>
  <tfoot>
    <tr>
      <td colspan="4" *ngIf="!loading && !emptyResult">
        <pagination [totalItems]="totalItems" [itemsPerPage]="itemsPerPage" [(ngModel)]="currentPage" [maxSize]="maxSize" class="pagination-md mb-0 justify-content-center" previousText="&lsaquo;" nextText="&rsaquo;" firstText="&laquo;"
          lastText="&raquo;" [boundaryLinks]="true" [rotate]="false" (numPages)="numPages = $event" (pageChanged)="pageChanged($event)"></pagination>
        <!-- <button (click)="setPage(2)">GO TO PAGE</button> -->
      </td>
    </tr>
  </tfoot>
</table>
<!-- </div> -->

<ng-template #newMsgModel let-modal>
  <div class="modal-header">
    <h5 class="modal-title" id="newMsgLabel">New Template</h5>
    <button type="button" class="close" (click)="modal.dismiss()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body" id="newMeta-modal-body">
    <form [formGroup]="newMsgForm" (ngSubmit)="onSubmit()">
      <small><i class="text-danger">* indicates mandatory field</i>&nbsp;<i class="fas fa-question-circle" placement="top"></i> &nbsp;<a target="_blank" [routerLink]="['/dashboard/support/msg-template']">View template field description</a></small>
      <div class="form-group row p-2">
        <div class="col-sm-6">
          <label for="shortCode" class="col-form-label"><span class="text-danger">* </span>ShortCode:</label>
          <input type="text" class="form-control" formControlName="shortCode">
          <div class="text-danger small" *ngIf="showError">
            <div *ngIf="f.shortCode.errors">
                Name cannot be blank.
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <label for="lang" class="col-form-label"><span class="text-danger">* </span>Language:</label>
          <input type="text" class="form-control" formControlName="lang">
          <div class="text-danger small" *ngIf="showError">
            <div *ngIf="f.lang.errors">
                Language cannot be blank.
            </div>
          </div>
        </div>
        <div class="col-sm-12">
          <label for="subInvalidMsg" class="col-form-label">Invalid Sub:</label>
          <input type="text" class="form-control" formControlName="subInvalidMsg">
        </div>
        <div class="col-sm-12">
          <label for="unsubInvalidMsg" class="col-form-label">Invalid UnSub:</label>
          <input type="text" class="form-control" formControlName="unsubInvalidMsg">
        </div>
        <div class="col-sm-12">
          <label for="subHelpMsg" class="col-form-label">Sub Help:</label>
          <input type="text" class="form-control" formControlName="subHelpMsg">
        </div>
        <div class="col-sm-12">
          <label for="unsubHelpMsg" class="col-form-label">Unsub Help:</label>
          <input type="text" class="form-control" formControlName="unsubHelpMsg">
        </div>
        <div class="col-sm-12">
          <label for="unsubAllMsg" class="col-form-label">UnSub All:</label>
          <input type="text" class="form-control" formControlName="unsubAllMsg">
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Close</button>
        <button type="submit" class="btn btn-primary" *ngIf="!processing">Add</button>
        <button type="submit" class="btn btn-primary" *ngIf="processing" disabled>Processing..</button>
      </div>
    </form>
  </div>
</ng-template>
